import {
  createValidationResult,
  findValueForPropertyInModelContext,
  IModelContext,
  IValidationResult,
  ModelItem,
  ValidationFunction,
  ValidationTypes
} from '@mng/model';
import {
  ITEM_ANGEBOTE_META_DATA_ZAHLUNGSART_FZ_KONTO,
  ITEM_ANGEBOTE_META_DATA_ZAHLUNGSART_PERSONALNUMMER
} from '../../../antrag.model.paths';
import { FzKonto } from '../../../antrag.model.types';

export const personalNummerValidation: ValidationFunction = (
  modelItem: ModelItem,
  modelContext: IModelContext
): IValidationResult => {
  if (modelContext.value) {
    const fzKonto: FzKonto = findValueForPropertyInModelContext(
      modelContext,
      ITEM_ANGEBOTE_META_DATA_ZAHLUNGSART_FZ_KONTO
    );

    if (fzKonto && fzKonto.personalNummerRegex && fzKonto.personalNummerRegex.length > 0) {
      const regex = new RegExp(fzKonto.personalNummerRegex);
      if (!regex.test(modelContext.value)) {
        // console.log('Die Personalnummer entspricht nicht dem Muster ' + fzKonto.personalNummerRegex);
        return createValidationResult(
          ITEM_ANGEBOTE_META_DATA_ZAHLUNGSART_PERSONALNUMMER,
          modelContext.value,
          `Die Personalnummer entspricht nicht dem erforderlichen Muster (${fzKonto.personalNummerExplanation})`
        );
      }
    }
  }

  return null;
};

export const fZKontoValidation: ValidationFunction = (
  modelItem: ModelItem,
  modelContext: IModelContext
): IValidationResult => {
  const valid = isValidFZKonto(modelContext.value);
  return valid ? null : createValidationResult(ValidationTypes.FZ_KONTO, valid);
};

/**
 * Validate FZ-Konto
 *
 * @example
 * // returns true
 * isValidFZKonto('1234');
 * @example
 * // returns true
 * isValidFZKonto('1234a');
 * @example
 * // returns true
 * isValidFZKonto('12345');
 * @example
 * // returns false
 * isValidFZKonto('123');
 * @example
 * // returns false
 * isValidFZKonto('123456');
 * @example
 * // returns false
 * isValidFZKonto('123a');
 *
 * @param kontoNr
 * @return valid
 */
export function isValidFZKonto(kontoNr: string): boolean {
  if (kontoNr) {
    return /^\d{4}[a-zA-Z|\d]?$/g.test(kontoNr);
  }
  return true;
}
